import React from "react";
import {FormModalProps} from "../../../../utils/useFormModal";
import {Form, Input, Modal, Switch} from "antd";

function ModifyModal(props: FormModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'code'} label={'编号'} rules={[{required: true}]}>
                    <Input/>
                </Form.Item>
                <Form.Item name={'name'} label={'名称'} rules={[{required: true}]}>
                    <Input/>
                </Form.Item>
                <Form.Item name={'oaId'} label={'OA ID'}>
                    <Input/>
                </Form.Item>
                <Form.Item name={'noRepeatGiveaway'} label={'赠品与样品叠加限制'} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal
